import styled, { createGlobalStyle } from 'styled-components'
import { type FC, type ReactNode, useEffect } from 'react'
import { useMapContext } from '../../../shared/contexts/map/MapContext'

const StyledDetailContainer = styled.div<{ $showMobile: boolean; $showLargeMap: boolean }>`
  display: ${(props) => (props.$showMobile ? 'flex' : 'none')};
  padding: 2.5rem 1rem 1rem 1rem;
  width: 100%;
  min-height: calc(100vh - var(--app-menu-height));
  flex-direction: column;
  overflow: auto;

  @media screen and (min-width: 48rem) {
    display: flex;
    width: ${(props) => (props.$showLargeMap ? '0%' : '50%')};
    padding: 2.5rem ${(props) => (props.$showLargeMap ? '0' : '36px')} 0;
  }
`

const BodyStyleForDetailPage = createGlobalStyle`
  // on the detail page it causes jumping content
  body {
    scrollbar-gutter: initial;
  }
`

const DetailContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const { showLargeMap, setPanelActive } = useMapContext()

  useEffect(() => {
    setPanelActive(true)

    return () => setPanelActive(false)
  }, [])

  return (
    <>
      <BodyStyleForDetailPage />
      <StyledDetailContainer $showMobile={!showLargeMap} $showLargeMap={showLargeMap}>
        {children}
      </StyledDetailContainer>
    </>
  )
}

export default DetailContainer
